// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".review-item[data-v-dfb9cc70] {\n  border: 1px solid var(--bs-white);\n  cursor: pointer;\n}\n.review-item[data-v-dfb9cc70]:hover {\n  border: 1px solid var(--bs-light);\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
